import { CommonFilterList, FilterConfig } from '../../../common/models/filter.model';
import { ALIGNMENT_ROUTES, INSIGHTS_ROUTES } from '../../../routes/routes.const';
import { FILTER_ITEMS } from './constants-filter-configs';

export const detailPaths = [ALIGNMENT_ROUTES.detail, INSIGHTS_ROUTES.detail];

interface FilterExclusions {
  [key: string]: string[];
}

export const CLIENT_FILTER_EXCLUSIONS: FilterExclusions = {
  PharmaMar: [CommonFilterList.Territory, CommonFilterList.Product, CommonFilterList.ManagerName],
  'Amicus Therapeutics': [CommonFilterList.Territory],
};

export const GLOBAL_FILTERS: FilterConfig[] = [
  FILTER_ITEMS.team,
  FILTER_ITEMS.territory,
  FILTER_ITEMS.accountCountry,
  FILTER_ITEMS.product,
  FILTER_ITEMS.managerName,
  FILTER_ITEMS.teamMember,
  FILTER_ITEMS.profile,
  FILTER_ITEMS.specialty,
];

export const CATALOG_IMAGE_PATH = '/src/assets/catalog/';
export const WIZARD_IMAGE_PATH = '/src/assets/wizard/';

export const WIDGET_REMOVE_CONFIRM_ID = 'widget-remove-confirm';

export const REPORT_REMOVE_CONFIRM_ID = 'report-remove-confirm';
export const PAGINATED_PPT_EXPORT_ROUTES: string[] = [
  `${INSIGHTS_ROUTES.summary}`,
  `${ALIGNMENT_ROUTES.summary}`,
];
